export const CLS_BTN_ICON_STD       = `btn-icon --std`

export const CLS_TOAST              = `toast`
export const CLS_TOAST_SUCCESS      = CLS_TOAST + ` fg-success`
export const CLS_TOAST_ERROR        = CLS_TOAST + ` fg-error`

export const CLS_IMG_STD            = `round-x2 h-18 t-md-h-13`

export const CLS_CARD_SERVICE_TEXT  = `fg-graphite font-std trans-cap`

export const CLS_BUY_BTN            = `btn-service maw-col-4 miw-col-2 --big round-x3 font-md`

export const CLS_GRID_CENTER_ROW_6  = `grid-flex --center row-6 d-xs-row-3 m-xl-row-2`